const ResumeApi = {
  data:{
    title: "Resume",
    
    list: [
      {
        id: 3,
        category: "education",
        title: "Software Engineer",
        degree: "",
        field_of_study_and_company_name: "Portonics Limited",
        year: "Mar 2020 - Present · 3 yrs (Continue", 
        desc: "- Requirement Analysis & Task Estimation.\n- Individual Feature Development.\n- UI-Driven Development with Programmatic UI Design.\n- Bug fixing and improving application performance.\n- Clean code and Re-usable components.\n- Unit Testing. \n- RESTful APIs to connect iOS applications to back-end services.",
        rate: "",
        skill: {
          model: ["iOS", "UIKit", "Xcode" , "Cocoa Touch", "REST APIs", "MVVM", "MVVM-c"]
        }
      },
      {
        id: 3,
        category: "education",
        title: "Web Developer",
        degree: "",
        field_of_study_and_company_name: "Portonics Limited",
        year: "May 2014 - Oct 2019 · 5 yrs 6 mos", 
        desc: "- Use markup languages like HTML to create user-friendly web pages.\n- Responsive and adaptive design.\n- Grunt, Gulp, Webpack",
        rate: "",
      },
      {
        id: 3,
        category: "education",
        title: "Web Developer",
        degree: "",
        field_of_study_and_company_name: "CREbsol",
        year: "Dec 2013 - May 2014 · 6 mos",
        desc: "CREbSoL, A Creative e-business solution company with four years experience on IT Solution of different platform. We have spent year to year developing our web marketing formula to create the most effective e-business model for your company. We incorporate some of the most impressive web designs in the world to deliver measured results for you.Our solutions can help save time and money and increase profits for your business.",
        rate: "3.26/",
      },
      {
        id: 3,
        category: "education",
        title: "Bangladesh University of Business and Technology (BUBT)",
        degree: "Bachelor of Science(B.Sc)",
        field_of_study_and_company_name: "Computer Science and Engineering",
        year: "2013-2017",
        desc: "",
        rate: "2.66/4",
      },
      {
        id: 3,
        category: "education",
        title: "Rangpur Polytechnic Institute",
        degree: "Diploma in Engineering",
        field_of_study_and_company_name: "Computer Technology",
        year: "2007-2011",
        desc: "",
        rate: "3.26/4",
      },
    ]
  }
}
  
  export default ResumeApi


  /*
  - Requirement Analysis & Task Estimation 
- UI-Driven Development with Programmatic UI Design
- MVVM-C Architecture for iOS Standard 
- Clean code and Re-usable components 
- Unit Testing
- Individual Feature Development
- Bug fixing and improving application performance.
- RESTful APIs to connect iOS applications to back-end services.

*/